module.exports = __webpack_public_path__ + "img/kopsurat_neurovi_default.d5f0ca8c.png";